import { render, staticRenderFns } from "./StaffForm.vue?vue&type=template&id=3465b1a3"
import script from "./StaffForm.vue?vue&type=script&lang=js"
export * from "./StaffForm.vue?vue&type=script&lang=js"
import style0 from "./StaffForm.vue?vue&type=style&index=0&id=3465b1a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports